import { render } from "./UserPickModal.vue?vue&type=template&id=74b52a22&scoped=true"
import script from "./UserPickModal.vue?vue&type=script&lang=js"
export * from "./UserPickModal.vue?vue&type=script&lang=js"

import "./UserPickModal.vue?vue&type=style&index=0&id=74b52a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b52a22"]])

export default __exports__